<div class="col">
  <div class="breadcrumb">
    <div
      class="breadcrumb-item"
      matTooltip="{{ item.localeText ? (item.localeText | localize) : item.text }}"
      matTooltipPosition="below"
      *ngFor="let item of breadcrumbList; last as isLast"
      [class.active]="isLast"
    >
      <a [routerLink]="item.link" *ngIf="!isLast">
        {{ item.localeText ? (item.localeText | localize) : item.text }}
      </a>
      <span *ngIf="isLast">{{ item.localeText ? (item.localeText | localize) : item.text }}</span>
    </div>
  </div>
</div>
